import environment from './core/environment/environment';
import {
    start,
} from  './core/lifecycle/start';

export default {
    start,
    environment,
};